import {
    UNITTYPE_EVENT_CREATE_EDIT_OPEN_MODAL,
    UNITTYPE_EVENT_CREATE_REQUEST,
    UNITTYPE_EVENT_CREATE_RESULT,
    UNITTYPE_EVENT_EDIT_REQUEST,
    UNITTYPE_EVENT_EDIT_RESULT,
    UNITTYPE_EVENT_GET_REQUEST,
    UNITTYPE_EVENT_GET_RESULT,
    UNITTYPE_EVENT_GET_UNIT_TYPES_REQUEST,
    UNITTYPE_EVENT_GET_UNIT_TYPES_RESULT,
} from 'Redux/actionTypes';

export const unitTypeEventCreateEditOpenModal = (open, unitTypeEvent) => ({
    type: UNITTYPE_EVENT_CREATE_EDIT_OPEN_MODAL,
    payload: { open, unitTypeEvent }
})

export const unitTypeEventCreateRequest = (data) => ({
    type: UNITTYPE_EVENT_CREATE_REQUEST,
    payload: data
})

export const unitTypeEventCreateResult = (result) => ({
    type: UNITTYPE_EVENT_CREATE_RESULT,
    payload: result
})

export const unitTypeEventEditRequest = (data) => ({
    type: UNITTYPE_EVENT_EDIT_REQUEST,
    payload: data
})

export const unitTypeEventEditResult = (result) => ({
    type: UNITTYPE_EVENT_EDIT_RESULT,
    payload: result
})

export const unitTypeEventGetRequest = (data) => ({
    type: UNITTYPE_EVENT_GET_REQUEST,
    payload: data
})

export const unitTypeEventGetResult = (result) => ({
    type: UNITTYPE_EVENT_GET_RESULT,
    payload: result
})

export const unitTypeEventSearchUnitTypeRequest = (data) => ({
    type: UNITTYPE_EVENT_GET_UNIT_TYPES_REQUEST,
    payload: data
})

export const unitTypeEventSearchUnitTypeResult = (result) => ({
    type: UNITTYPE_EVENT_GET_UNIT_TYPES_RESULT,
    payload: result
})